<ion-grid>
  <ion-row>
    <ion-col size-xs="12">
      <span style="color: var(--ion-color-primary); font-weight: 700; font-size: 18px;">{{ toolTipTitle }} Definition</span>
    </ion-col>
  </ion-row>
  <ion-row class="ion-text-left">
    <ion-col size="12" class="responsive-font-size ion-align-self-center">
      <div *ngFor="let toolTipDetail of toolTipDetails">
        <p>{{ toolTipDetail }}</p> 
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-xs="12" style="margin-bottom: 10px;">
      <span style="color: white; font-weight: 700; font-size: 18px;"> {{ toolTipTitle }} Image Examples</span>
    </ion-col>
  </ion-row>
  <ion-row class="ion-no-padding ion-align-items-center" *ngFor="let name of classList">
    <ion-col class="ion-no-padding ion-text-center" style="color: white; font-weight: 600;" size-xs="3">
      {{ name }}
    </ion-col>
    <ion-col size-xs="3" *ngFor="let picture of pictureList[name]">
      <img width="200" height="200"  [src]="picture"/>
    </ion-col>
  </ion-row>
</ion-grid>
